var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInsights = function SvgInsights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15 3c1.037 0 1.875.838 1.875 1.875V18A1.873 1.873 0 0 1 15 19.875h-.469a1.873 1.873 0 0 1-1.875 1.875h-.937a1.873 1.873 0 0 1-1.875-1.875h-.469A1.873 1.873 0 0 1 7.5 18V4.875C7.5 3.838 8.338 3 9.375 3zM1.875 27.375H18.75a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 0-7.5-7.5v-3.75c6.21 0 11.25 5.04 11.25 11.25a11.21 11.21 0 0 1-2.865 7.5h.99c1.037 0 1.875.838 1.875 1.875a1.873 1.873 0 0 1-1.875 1.875H1.875A1.873 1.873 0 0 1 0 29.25c0-1.037.838-1.875 1.875-1.875"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.4,
    fillRule: "nonzero",
    d: "M6.563 23.625h11.25a.94.94 0 0 1 .937.938.94.94 0 0 1-.938.937H6.563a.94.94 0 0 1-.937-.938.94.94 0 0 1 .938-.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.4,
    d: "M10 0h4a1 1 0 0 1 1 1v2H9V1a1 1 0 0 1 1-1"
  }))));
};
export default SvgInsights;